import { forwardRef, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime } from 'rxjs/operators';
import { SegmentApi } from '../../../api/segments.api';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var INPUT_FIELD_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SegmentsComponent; }),
    multi: true,
};
var SegmentsComponent = /** @class */ (function () {
    function SegmentsComponent(fuseTranslationLoaderService, segmentsApi) {
        var _this = this;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.segmentsApi = segmentsApi;
        this.required = true;
        this.appearance = 'outline';
        this.segmentValue = false;
        this.limit = 50;
        this.segments = [];
        this.selectValue = new FormControl();
        this.onChange = function () { };
        this.onTouched = function () { };
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.selectValue.valueChanges.pipe(debounceTime(500)).subscribe(function (value) {
            if (value) {
                _this.onChange(value);
            }
        });
    }
    SegmentsComponent.prototype.ngOnInit = function () {
        this.searchSegments();
        if (this.disabled) {
            this.selectValue.disable();
        }
        if (this.required) {
            this.selectValue.setValidators(Validators.required);
        }
    };
    SegmentsComponent.prototype.searchSegments = function () {
        var _this = this;
        var query = {
            archived: false
        };
        var options = {
            orderColumn: 'name',
            order: 'asc',
            limit: this.limit
        };
        this.segmentsApi.search(query, options).subscribe(function (result) {
            _this.segments = result.items;
            if (_this.selectValue.value) {
                var currentSegmentIsOnList = _this.segments.some(function (segment) {
                    return segment.id === _this.selectValue.value.id;
                });
                if (!currentSegmentIsOnList) {
                    _this.segments.push(_this.selectValue.value);
                }
            }
        });
    };
    SegmentsComponent.prototype.writeValue = function (segment) {
        this.selectValue.setValue(segment);
    };
    SegmentsComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    SegmentsComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SegmentsComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
        if (isDisabled) {
            this.selectValue.disable();
        }
        else {
            this.selectValue.enable();
        }
    };
    return SegmentsComponent;
}());
export { SegmentsComponent };
